import React, { useEffect, useState, useRef } from 'react';
import config from '../../../config/config';
import Sidebar from '../Sidebar';
import { Card, Col, Row, Button, Form, ProgressBar } from 'react-bootstrap';
import DashboardHeader from '../DashboardHeader';
import '../css/Dashboard.css';
import '../css/Custom.css';
import Footer from '../DashboardFooter';
import { getFormDetailsById } from '../../../Action/action';
import { useParams, useNavigate } from 'react-router-dom';
import Web3WalletProvider from '../../../ConnectWallet/walletProvider';
import { useAccount } from 'wagmi';
import {
  getUsdtBalance,
  ApproveUsdtToken,
  BuyTokenUsdt,
  UsdtEarned,
  TokenSaleDuration2,
  UserUsdt,
  UserToken,
  RefundStat,
  PreSaleData,
} from '../../../Web3/Connector';
import { toast, Toaster } from 'react-hot-toast';
import ReactApexChart from 'react-apexcharts';
import { showLoader, hideLoader } from '../../loader';
import ReadMore from '../../readmore';

const Buy = ({ special, clearModalData }) => {
  const { id } = useParams();
  const [form, setForm] = useState([]);
  const _useWeb3WalletProvider = Web3WalletProvider();
  const { address, isConnected } = useAccount();
  const [UsdtAmount, setUsdtAmount] = useState(0);
  const [token, setToken] = useState(0);
  const [isUsdtApproved, setisUsdtApproved] = useState(false);
  const [isProviderLoaded, setisProviderLoaded] = useState(false);
  const [err, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isProviderLoaded) {
      _useWeb3WalletProvider.then((data) => {
        if (data) {
          setisProviderLoaded(true);
        }
      });
    }
  }, [_useWeb3WalletProvider]);

  useEffect(() => {
    if (isProviderLoaded) {
      getFormData();
    }
  }, [isProviderLoaded]);

  const getFormData = async () => {
    try {
      const response = await getFormDetailsById({ id });
      // console.log('FORM', response.data)
      if (response.success) {
        if (response.data.length > 0) {
          let dResult = await checkDuration(response.data[0]);
          response.data[0].newD = dResult.duration;
          response.data[0].td = dResult.time;
          response.data[0].timeLeft = dResult.remainingTime;

          let walletBalance = await walletUsdtBalance(response.data[0]);
          response.data[0].bal = walletBalance;

          let capUsdt = await usdtEarnings(response.data[0]);
          response.data[0].usdtBal = capUsdt;

          let tokenresult = await usertoken(response.data[0]);
          response.data[0].tokenUser = tokenresult;

          let usdtresult = await userusdt(response.data[0]);
          response.data[0].usdtUser = usdtresult;

          let tok = await tokenomics(response.data[0]);
          setChart(tok);

          let refund = await refundStat(response.data[0]);
          response.data[0].isRefunded = refund;

          let pre = await preData(response.data[0]);
          response.data[0].totalSold = pre.Sold;
          response.data[0].totalLeft = pre.Available;
        }
        console.log('FORM2', response.data);
        setForm(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkDuration = async (formData) => {
    let request = {
      walletProvider: _useWeb3WalletProvider,
      tokenAddress: formData.token_address,
      preSaleAddress: formData.presaleContract,
      networkId: formData.chainNetworkId,
    };
    let endTime = await TokenSaleDuration2(request);
    const d2 = Number(endTime?.time);
    const now = Math.floor(Date.now() / 1000);
    const remainingTime = d2 - now;
    //console.log('zz', now, remainingTime, endTime.time);
    return { duration: endTime.duration, time: endTime.time, remainingTime };
  };

  const formatTimeLeft = (timeLeft) => {
    if (timeLeft <= 0) {
      return '0 Days, 0 Hours, 0 Minutes';
    }
    let days = Math.floor(timeLeft / 86400);
    let hours = Math.floor((timeLeft % 86400) / 3600);
    let minutes = Math.floor((timeLeft % 3600) / 60);

    return `${days} Days, ${hours} Hours, ${minutes} Minutes`;
  };

  const walletUsdtBalance = async (formData) => {
    let request = {
      walletProvider: _useWeb3WalletProvider,
      tokenAddress: formData.token_address,
      tokenAmount: formData.token_amount,
      UsdtPrice: formData.usdt_price,
      preSaleAddress: formData.presaleContract,
      usdtAddress: formData.usdtContract,
      networkId: formData.chainNetworkId,
      buyAmount: UsdtAmount,
    };
    const res = await getUsdtBalance(request);
    //console.log('BAL', res)
    //setUsdtBalance(res?.balance || 0);
    return res?.balance || 0;
  };

  const preData = async (formData) => {
    let request = {
      walletProvider: _useWeb3WalletProvider,
      tokenAddress: formData.token_address,
      tokenAmount: formData.token_amount,
      UsdtPrice: formData.usdt_price,
      preSaleAddress: formData.presaleContract,
      usdtAddress: formData.usdtContract,
      networkId: formData.chainNetworkId,
      buyAmount: UsdtAmount,
    };
    const res = await PreSaleData(request);
    return res;
  };

  const usdtEarnings = async (formData) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: formData.token_address,
        preSaleAddress: formData.presaleContract,
        networkId: formData.chainNetworkId,
      };
      let bal = await UsdtEarned(request);
      return bal.usdtAmount;
    } catch (error) {
      console.log(error);
    }
  };

  const usertoken = async (formData) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: formData.token_address,
        preSaleAddress: formData.presaleContract,
        networkId: formData.chainNetworkId,
      };
      //console.log('tokenreq', request)
      let bal = await UserToken(request);
      //console.log('TTTTTT', bal)
      return bal.tokenAmt;
    } catch (error) {
      console.log(error);
    }
  };

  const userusdt = async (formData) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: formData.token_address,
        preSaleAddress: formData.presaleContract,
        usdtAddress: formData.usdtContract,
        networkId: formData.chainNetworkId,
      };
      //console.log('usdtreq', request)
      let bal = await UserUsdt(request);
      //console.log('UserUSDT', bal)
      return bal.usdtAmt / 10 ** 6;
    } catch (error) {
      console.log(error);
    }
  };

  const tokenomics = async (formData) => {
    const { private_sale, ico, team, partnerships, others } = formData;
    return (prevChart) => ({
      ...prevChart,
      series: [private_sale, ico, team, partnerships, others],
    });
  };

  const refundStat = async (formData) => {
    try {
      let request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: formData.token_address,
        preSaleAddress: formData.presaleContract,
        networkId: formData.chainNetworkId,
      };
      let status = await RefundStat(request);
      //console.log('refund?', status)
      return status;
    } catch (error) {
      console.log(error);
    }
  };

  const onchangehandlerUsdt = (e) => {
    const { value } = e.target;
    setisUsdtApproved(false);
    setError('');
    setUsdtAmount(value);
    let tokenVal = parseFloat(value / form[0].usdt_price).toFixed(6);
    console.log('1111', value, form[0].usdt_price, tokenVal);
    if (tokenVal > form[0].token_amount) {
      setError('Cannot buy more than sale amount');
    } else {
      setToken(tokenVal);
    }
  };

  // const handleUsdtBuy = async (e) => {
  //   e.preventDefault();
  //   if (!isConnected) {
  //     toast.error('Please connect your wallet');
  //   }
  //   showLoader();
  //   try {
  //     let request = {
  //       walletProvider: _useWeb3WalletProvider,
  //       tokenAddress: form.length > 0 ? form[0].token_address : '',
  //       tokenAmount: form.length > 0 ? form[0].token_amount : '',
  //       UsdtPrice: form.length > 0 ? form[0].usdt_price : '',
  //       preSaleAddress: form.length > 0 ? form[0].presaleContract : '',
  //       usdtAddress: form.length > 0 ? form[0].usdtContract : '',
  //       networkId: form.length > 0 ? form[0].chainNetworkId : '',
  //       buyAmount: UsdtAmount,
  //     };

  //     let bala = await getUsdtBalance(request);
  //     if (bala?.balance <= 0) {
  //       toast.error('Not enough USDT Balance');
  //       setToken('');
  //       setUsdtAmount('');
  //     }
  //     let approval = await ApproveUsdtToken(request);
  //     if (approval.status) {
  //       //console.log('APP', approval);
  //       let resBuy = await BuyTokenUsdt(request);
  //       //console.log('BUY', resBuy)
  //       if (resBuy.status) {
  //         toast.success(resBuy.message, { autoClose: 8000 });
  //         setUsdtAmount('');
  //         setToken('');
  //         window.location.reload();
  //       } else {
  //         toast.error(resBuy.message);
  //         setUsdtAmount('');
  //         setToken('');
  //       }
  //     } else {
  //       toast.error(approval.message);
  //       setUsdtAmount('');
  //       setToken('');
  //     }
  //   } catch (error) {
  //     console.log('Error Buy Usdt', error);
  //     toast.error('USDT BUY Error', error);
  //     setUsdtAmount('');
  //     setToken('');
  //   } finally {
  //     hideLoader();
  //     setUsdtAmount('');
  //     setToken('');
  //   }
  // };

  // const handleClaim = async (e) => {
  //   e.preventDefault();
  //   if (!isConnected) {
  //     toast.error('Please connect your wallet');
  //     return;
  //   }
  //   if (claimed) return;
  //   showLoader();
  //   try {
  //     let request = {
  //       walletProvider: _useWeb3WalletProvider,
  //       tokenAddress: form.length > 0 ? form[0].token_address : '',
  //       preSaleAddress: form.length > 0 ? form[0].presaleContract : '',
  //       networkId: form.length > 0 ? form[0].chainNetworkId : '',
  //     };
  //     let resClaim = await ClaimToken(request);
  //     if (resClaim.status) {
  //       toast.success(resClaim.message);
  //       setClaimed(true);
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 2000);
  //     } else {
  //       toast.error(resClaim.message);
  //     }
  //   } catch (error) {
  //     console.log('Error Claim', error);
  //     toast.error('Token Claim Error', error);
  //   } finally {
  //     hideLoader();
  //   }
  // };

  // const handleRefund = async (e) => {
  //   e.preventDefault();
  //   if (!isConnected) {
  //     toast.error('Please connect your wallet');
  //     return;
  //   }

  //   if (refunded) return;
  //   showLoader();
  //   try {
  //     let request = {
  //       walletProvider: _useWeb3WalletProvider,
  //       tokenAddress: form.length > 0 ? form[0].token_address : '',
  //       preSaleAddress: form.length > 0 ? form[0].presaleContract : '',
  //       networkId: form.length > 0 ? form[0].chainNetworkId : '',
  //     };

  //     let resRefund = await RefundTokens(request);
  //     if (resRefund.status) {
  //       setRefunded(true);
  //       toast.success(resRefund.message);
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 2000);
  //     } else {
  //       toast.error(resRefund.message);
  //     }
  //   } catch (error) {
  //     console.log('Error Refund', error);
  //     toast.error('Token Refund Error', error);
  //   } finally {
  //     hideLoader();
  //   }
  // };

  const handleUsdtBuy = async (e) => {
    e.preventDefault();

    if (!isConnected) {
      toast.error('Please connect your wallet');
      return;
    }

    showLoader();

    try {
      const request = {
        walletProvider: _useWeb3WalletProvider,
        tokenAddress: form.length > 0 ? form[0].token_address : '',
        tokenAmount: form.length > 0 ? form[0].token_amount : '',
        UsdtPrice: form.length > 0 ? form[0].usdt_price : '',
        preSaleAddress: form.length > 0 ? form[0].presaleContract : '',
        usdtAddress: form.length > 0 ? form[0].usdtContract : '',
        networkId: form.length > 0 ? form[0].chainNetworkId : '',
        buyAmount: UsdtAmount,
      };

      // Step 1: Check balance
      const bala = await getUsdtBalance(request);
      if (!bala || parseFloat(bala.balance) <= 0) {
        toast.error('Not enough USDT Balance');
        return;
      }

      // Step 2: USDT Approval
      const approval = await ApproveUsdtToken(request);
      if (!approval.status) {
        toast.error(approval.message || 'USDT approval failed');
        return;
      }

      if (!approval.alreadyApproved) {
        toast.success('USDT approved successfully');
      }

      // Step 3: Buy
      const resBuy = await BuyTokenUsdt(request);
      if (resBuy.status) {
        toast.success(resBuy.message, { autoClose: 8000 });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(resBuy.message || 'Purchase failed');
      }
    } catch (error) {
      console.error('Error Buy USDT:', error);
      toast.error('USDT BUY Error');
    } finally {
      hideLoader();
      setUsdtAmount('');
      setToken('');
    }
  };

  const chartStyle = {
    maxWidth: '400px',
    padding: '20px',
    background: 'linear-gradient(45deg, #fff, transparent)',
    borderRadius: '10px',
    // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  };

  const [chart, setChart] = useState({
    series: [0, 0, 0, 0, 0],
    options: {
      chart: {
        type: 'donut',
      },
      labels: ['Private Sale', 'ICO', 'Team', 'Partnerships', 'Others'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: '100%',
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  });

  function formatLargeNumber(number) {
    if (number === null || number === undefined || number === '') {
      return '';
    }

    if (number >= 1e12) {
      return number / 1e12 + 'T'; // Trillions
    } else if (number >= 1e9) {
      return number / 1e9 + 'B'; // Billions
    } else if (number >= 1e6) {
      return number / 1e6 + 'M'; // Millions
    } else if (number >= 1e3) {
      return number / 1e3 + 'K'; // Thousands
    } else {
      return number.toString();
    }
  }

  const formatDuration = (days) => {
    let totalSeconds = Math.floor(days * 86400);
    let d = Math.floor(totalSeconds / 86400);
    let h = Math.floor((totalSeconds % 86400) / 3600);
    let m = Math.floor((totalSeconds % 3600) / 60);

    if (d > 0) return `${d} Days`;
    if (h > 0) return `${h} Hours`;
    return `${m} Minutes`;
  };

  const AMEAllocation = () => {
    window.location.href = `${config.baseUrl}projectoverview`; // Replace with your desired URL
  };

  return (
    <>
      <Toaster />
      <div
        className="dashboard w-100"
        style={{ minHeight: '100vh', overflow: 'hidden' }}
      >
        <div className="d-flex  w-100 h-100">
          <Sidebar special={special} clearModalData={clearModalData} />

          <div className="w-100" style={{ height: '100%' }}>
            <DashboardHeader />
            <div className="main-panel">
              <div
                className="content-wrapper px-4 px-lg-4"
                style={{
                  // padding: "15px",
                  flex: '1',
                  backgroundColor: '#000',
                  color: '#ffffff',
                  height: '100%',
                  overflowY: 'auto',
                }}
              >
                {isLoading ? (
                  <div className="p-sm-4 text-center">
                    <img
                      src={`${config.baseUrl}images/loader.gif`}
                      width="30px"
                      alt=""
                    />
                  </div>
                ) : (
                  <Row className="gy-3 pt-4">
                    {form.length > 0 && (
                      <Col
                        xxl={9}
                        xl={9}
                        lg={12}
                        md={12}
                        sm={12}
                        className="mb-4"
                      >
                        <Card className="dashboard-card dash-gradient2 overflow-hidden d-flex">
                          <Card.Body className="">
                            <Row className="align-items-center">
                              <Col lg={3} md={3} sm={3} className="mb-3">
                                <div className=" d-icon text-center">
                                  <img
                                    src={`${config.imagePath}${form[0].brand_logo}`}
                                    className="object-fit-contain rounded-2"
                                    alt=""
                                    width={`100%`}
                                    height={`138px`}
                                  />
                                </div>
                              </Col>
                              <Col lg={9} md={9} sm={9} className="mb-3">
                                <div className="">
                                  <Row className="align-items-center">
                                    <Col xl={8} lg={8} md={8}>
                                      <h5 className="text-white mb-xxl-2 lh-base">
                                        <h2>{form[0].token_name}</h2>
                                      </h5>
                                      <p className="mb-0 text-light-grey small">
                                        {form[0].description.length > 100 ? (
                                          <p>
                                            <ReadMore
                                              text={form[0].description}
                                              maxLength={100}
                                            />
                                          </p>
                                        ) : (
                                          <p>{form[0].description}</p>
                                        )}
                                      </p>
                                    </Col>
                                    <Col xl={4} lg={4} md={4}>
                                      <div>
                                        <Button
                                          variant="outline-primary"
                                          className="w-100 mb-3 rounded-5 bg-transparent"
                                          href={`${form[0].website}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Website
                                        </Button>
                                        <Button
                                          variant="outline-primary"
                                          className="w-100 rounded-5 bg-transparent"
                                          href={`${form[0].whitepaper}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Whitepaper
                                        </Button>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                            <hr className="mt-0" />
                            <div>
                              <Row>
                                <Col lg={2} md={3} sm={4} className="mb-3">
                                  <div>
                                    <small className="text-light-grey2">
                                      Total Supply
                                    </small>
                                    <p className="text-white mb-0">
                                      {formatLargeNumber(form[0].liquidity)}
                                    </p>
                                  </div>
                                </Col>
                                <Col lg={2} md={3} sm={4} className="mb-3">
                                  <div>
                                    <small className="text-light-grey2">
                                      Tokens For Sale
                                    </small>
                                    <p className="text-white mb-0">
                                      {formatLargeNumber(form[0].token_amount)}
                                    </p>
                                  </div>
                                </Col>
                                <Col lg={2} md={3} sm={4} className="mb-3">
                                  <div>
                                    <small className="text-light-grey2">
                                      Price
                                    </small>
                                    {console.log('ppppp', form[0].usdt_price)}
                                    <p className="text-white mb-0">
                                      {form[0].usdt_price < 0.0001
                                        ? form[0].usdt_price
                                        : parseFloat(
                                            form[0].usdt_price
                                          ).toString()}{' '}
                                      USDT
                                    </p>
                                  </div>
                                </Col>
                                <Col lg={2} md={3} sm={4} className="mb-3">
                                  <div>
                                    <small className="text-light-grey2">
                                      Start Date
                                    </small>
                                    <p className="text-white mb-0">
                                      {' '}
                                      {
                                        new Date(form[0].update_at)
                                          .toISOString()
                                          .split('T')[0]
                                      }
                                    </p>
                                  </div>
                                </Col>
                                <Col lg={2} md={3} sm={4} className="mb-2">
                                  <div>
                                    <small className="text-light-grey2">
                                      Token Address
                                    </small>
                                    <p className="text-white">
                                      <a
                                        href={`${form[0].chainExplorerUrl}/address/${form[0].token_address}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {form[0].token_address
                                          .toString()
                                          .substring(0, 4) +
                                          '....' +
                                          form[0].token_address
                                            .toString()
                                            .substring(
                                              form[0].token_address.length - 4,
                                              form[0].token_address.length
                                            )}
                                      </a>{' '}
                                      <span
                                        className="copyIcon"
                                        onClick={() =>
                                          navigator.clipboard.writeText(
                                            form[0].token_address
                                          )
                                        }
                                        style={{ cursor: 'pointer' }}
                                        title="Copy to clipboard"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 25"
                                          fill="none"
                                        >
                                          <path
                                            d="M5 15.5C4.06812 15.5 3.60218 15.5 3.23463 15.3478C2.74458 15.1448 2.35523 14.7554 2.15224 14.2654C2 13.8978 2 13.4319 2 12.5V5.7C2 4.5799 2 4.01984 2.21799 3.59202C2.40973 3.21569 2.71569 2.90973 3.09202 2.71799C3.51984 2.5 4.0799 2.5 5.2 2.5H12C12.9319 2.5 13.3978 2.5 13.7654 2.65224C14.2554 2.85523 14.6448 3.24458 14.8478 3.73463C15 4.10218 15 4.56812 15 5.5M12.2 22.5H18.8C19.9201 22.5 20.4802 22.5 20.908 22.282C21.2843 22.0903 21.5903 21.7843 21.782 21.408C22 20.9802 22 20.4201 22 19.3V12.7C22 11.5799 22 11.0198 21.782 10.592C21.5903 10.2157 21.2843 9.90973 20.908 9.71799C20.4802 9.5 19.9201 9.5 18.8 9.5H12.2C11.0799 9.5 10.5198 9.5 10.092 9.71799C9.71569 9.90973 9.40973 10.2157 9.21799 10.592C9 11.0198 9 11.5799 9 12.7V19.3C9 20.4201 9 20.9802 9.21799 21.408C9.40973 21.7843 9.71569 22.0903 10.092 22.282C10.5198 22.5 11.0799 22.5 12.2 22.5Z"
                                            stroke="grey"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                      </span>
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                            <hr className="mt-0" />
                            <div>
                              <Row>
                                <Col lg={12} className="mb-3">
                                  <div className="mb-3">
                                    <h6 className="text-white fw-normal">
                                      Token Sale Progress
                                    </h6>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <div className="text-white small">
                                      <span className="text-light-grey2">
                                        Time Left&nbsp;:&nbsp;{' '}
                                      </span>
                                      {formatTimeLeft(form[0].timeLeft)}
                                    </div>
                                    <div className="text-white small">
                                      <span className="text-light-grey2">
                                        Tokens Left&nbsp;:&nbsp;
                                      </span>
                                      {form[0].totalLeft.toFixed(2)}
                                    </div>
                                  </div>
                                  <div className="py-1">
                                    <ProgressBar
                                      now={
                                        (form[0].usdtBal / form[0].hard_cap) *
                                        100
                                      }
                                      animated
                                    />
                                  </div>
                                  <span className="text-light-grey2">
                                    {Math.min(
                                      100,
                                      (form[0]?.usdtBal / form[0]?.hard_cap) *
                                        100
                                    ).toFixed(2)}
                                    % raised
                                  </span>
                                  <div className="d-flex justify-content-between">
                                    <div className="text-white small">
                                      <span className="text-light-grey2">
                                        SoftCap&nbsp;:&nbsp;
                                      </span>
                                      {form[0]?.soft_cap} USDT
                                    </div>
                                    <div className="text-white small">
                                      <span className="text-light-grey2">
                                        <span
                                          className={` ${
                                            form[0]?.usdtBal >=
                                            form[0]?.hard_cap
                                              ? 'line-through text-gray-500'
                                              : ''
                                          }`}
                                        >
                                          Raised:{' '}
                                        </span>
                                        {console.log(
                                          'xxxx',
                                          form[0].usdtBal,
                                          form[0].hard_cap
                                        )}
                                        {form[0]?.usdtBal >=
                                        form[0]?.hard_cap ? (
                                          <span className="text-success">
                                            FILLED
                                          </span>
                                        ) : (
                                          `${form[0]?.usdtBal} USDT`
                                        )}
                                      </span>
                                    </div>
                                    <div className="text-white small">
                                      <span className="text-light-grey2">
                                        HardCap:
                                      </span>
                                      {form[0]?.hard_cap} USDT
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={6} className="mb-3">
                                  <div className="piechart">
                                    <div id="chart" style={chartStyle}>
                                      <ReactApexChart
                                        options={chart.options}
                                        series={chart.series}
                                        type="donut"
                                      />
                                    </div>
                                  </div>
                                </Col>
                                {!form[0].newD ? (
                                  <Col lg={6} className="mb-3">
                                    <div>
                                      <h5 className="text-white fw-normal mb-3">
                                        My Allocation: {form[0]?.tokenUser || 0}{' '}
                                        {form[0].token_name}
                                      </h5>
                                      <div className="mb-3">
                                        <Form.Label>Buy</Form.Label>
                                        <div className="text-end">
                                          <Form.Text className="text-white">
                                            USDT Balance:{' '}
                                            {form[0].bal.toFixed(6)} USDT
                                          </Form.Text>
                                        </div>
                                        <Form.Control
                                          aria-describedby="basic-addon2"
                                          name="UsdtAmount"
                                          onChange={onchangehandlerUsdt}
                                          disabled={
                                            form[0]?.usdtBal >=
                                            form[0]?.hard_cap
                                          }
                                        />
                                      </div>

                                      <div className="mb-3">
                                        <Form.Label>
                                          {form[0].token_name} Token
                                        </Form.Label>
                                        <Form.Control
                                          aria-describedby="basic-addon2"
                                          name="tokenAmt"
                                          value={token || ''}
                                          onChange={onchangehandlerUsdt}
                                          disabled
                                        />
                                        {err && (
                                          <p style={{ color: 'red' }}>{err}</p>
                                        )}
                                      </div>
                                      <div>
                                        <div className="pricedetail d-flex justify-content-between align-items-end">
                                          <div>
                                            <div className="small text-light-grey2 mb-2">
                                              <span>Step 1 :</span> Approve USDT
                                            </div>
                                            <div className="small text-light-grey2 mb-2">
                                              <span>Step 2 :</span> Buy{' '}
                                              {`${form[0].token_name}`} Token
                                            </div>
                                          </div>
                                          <div>
                                            {!isUsdtApproved && (
                                              <Button
                                                className="px-4 rounded-5"
                                                onClick={(e) =>
                                                  handleUsdtBuy(e)
                                                }
                                                disabled={
                                                  !UsdtAmount ||
                                                  err ||
                                                  form[0]?.usdtBal >=
                                                    form[0]?.hard_cap
                                                }
                                              >
                                                Buy Now
                                              </Button>
                                            )}
                                          </div>
                                          <div>
                                            {isUsdtApproved && (
                                              <Button
                                                className="px-4 rounded-5"
                                                onClick={(e) =>
                                                  handleUsdtBuy(e)
                                                }
                                              >
                                                Buy Now
                                              </Button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                ) : (
                                  ''
                                  //   <>
                                  //   {form.length > 0 && (
                                  //     <Col lg={6} className="mb-3">
                                  //       <div className="pricedetail">
                                  //         <div>
                                  //           <Row>
                                  //             <Col lg={8} className="mb-3">
                                  //               <div>
                                  //                 <small className="text-light-grey2">
                                  //                   Token Name
                                  //                 </small>
                                  //                 <p className="text-white mb-0">
                                  //                   {form[0].token_name}
                                  //                 </p>
                                  //               </div>
                                  //             </Col>
                                  //             <Col lg={4} className="mb-3">
                                  //               <div>
                                  //                 <small className="text-light-grey2">
                                  //                   {form[0].soft_cap >
                                  //                   form[0].usdtBal ? (
                                  //                     <span>USDT</span>
                                  //                   ) : (
                                  //                     <span>Token Amount</span>
                                  //                   )}
                                  //                 </small>
                                  //                 <p className="text-white mb-0">
                                  //                   {form[0].soft_cap >
                                  //                   form[0].usdtBal
                                  //                     ? refunded
                                  //                       ? 0
                                  //                       : form[0].usdtUser
                                  //                     : claimed
                                  //                     ? 0
                                  //                     : form[0].tokenUser}
                                  //                 </p>
                                  //               </div>
                                  //             </Col>
                                  //           </Row>
                                  //         </div>
                                  //         <div>
                                  //           <div>
                                  //             {form[0]?.soft_cap >
                                  //             form[0]?.usdtBal ? (
                                  //               <Button
                                  //                 className="px-5 rounded-5"
                                  //                 onClick={(e) => handleRefund(e)}
                                  //                 disabled={
                                  //                   form[0].usdtUser === 0 ||
                                  //                   refunded
                                  //                 }
                                  //               >
                                  //                 {refunded
                                  //                   ? 'Refunded'
                                  //                   : 'Refund'}
                                  //               </Button>
                                  //             ) : (
                                  //               <Button
                                  //                 className="px-5 rounded-5"
                                  //                 onClick={(e) => handleClaim(e)}
                                  //                 disabled={
                                  //                   form[0].tokenUser === 0 ||
                                  //                   claimed
                                  //                 }
                                  //               >
                                  //                 {console.log('1001', claimed)}
                                  //                 {claimed ? 'Claimed' : 'Claim'}
                                  //               </Button>
                                  //             )}
                                  //           </div>
                                  //         </div>
                                  //       </div>
                                  //     </Col>
                                  //   )}
                                  // </>
                                )}
                              </Row>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    )}

                    <Col
                      xxl={3}
                      xl={3}
                      lg={12}
                      md={12}
                      sm={12}
                      className="mb-4"
                    >
                      <Card className="dashboard-card box-gradient p-3 d-flex overflow-hidden gap-3 bgparticle mb-3">
                        <Card.Body className="">
                          <div className="d-flex gap-3 justify-content-center align-items-center position-relative">
                            <div className="text-center">
                              <div className="mb-2">
                                <span className="SbSeIcon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 64 60"
                                    fill="none"
                                  >
                                    <path
                                      d="M4.91484 37.1137L16.795 30.2547L28.6751 37.1137V50.8317L16.795 57.6907L4.91484 50.8317V37.1137Z"
                                      stroke="white"
                                      stroke-width="4"
                                    />
                                    <path
                                      d="M35.326 37.1137L47.2061 30.2547L59.0862 37.1137V50.8317L47.2061 57.6907L35.326 50.8317V37.1137Z"
                                      stroke="white"
                                      stroke-width="4"
                                    />
                                    <path
                                      d="M21.3533 9.1684L33.2335 2.3094L45.1136 9.1684V22.8864L33.2335 29.7454L21.3533 22.8864V9.1684Z"
                                      stroke="white"
                                      stroke-width="4"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <h5 className="text-white lh-base">
                                SbSe Protocol
                              </h5>
                            </div>
                          </div>
                        </Card.Body>
                        <div
                          className="bottom position-absolute top-0 start-0 bottom-0
                                        end-0"
                        >
                          <img
                            src={`${config.baseUrl}images/dashboard/shape/ellipseCard.svg`}
                            width={`100%`}
                            height={`100%`}
                            alt=""
                          />
                        </div>
                      </Card>
                      <Card className="dashboard-card box-gradient p-3 d-flex overflow-hidden gap-3 bgparticle mb-3">
                        <Card.Body className="">
                          <div className=" d-flex gap-3 justify-content-center align-items-center">
                            <div className="text-center">
                              <div className="mb-2">
                                <span className="SbSeIcon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 52 63"
                                    fill="none"
                                  >
                                    <path
                                      d="M22.9266 38.2183C20.0264 36.9753 16.6609 36.7213 14.4471 36.8681C13.8523 36.9076 13.3117 36.4678 13.2833 35.8723L13.1785 33.6705C13.1407 32.8769 12.2372 32.4422 11.5935 32.9078L2.68197 39.3544C2.12194 39.7596 2.13198 40.5971 2.70156 40.9887L11.77 47.2232C12.4335 47.6794 13.3365 47.2044 13.3365 46.3992V44.874C13.3365 44.3217 13.784 43.874 14.3363 43.874C16.0184 43.874 18.5347 43.874 19.9758 43.874C21.6871 43.874 22.6173 45.8649 22.8996 46.9603C22.9185 47.0336 22.9266 47.1089 22.9266 47.1846V60.333C22.9266 60.8853 23.3744 61.333 23.9266 61.333H28.566C29.1183 61.333 29.566 60.8853 29.566 60.333V45.1035M22.9266 38.2183C26.1234 39.4478 28.8283 42.8904 29.566 45.1035M22.9266 38.2183V14.7833C22.9266 14.2677 22.5347 13.8367 22.0215 13.7878L19.4903 13.5467C18.7233 13.4737 18.3235 12.597 18.7714 11.97L25.5555 2.47223C25.9544 1.91389 26.7842 1.91389 27.183 2.47223L33.8464 11.801C34.3191 12.4628 33.846 13.3822 33.0326 13.3822H30.566C30.0137 13.3822 29.566 13.8299 29.566 14.3822V23.956M29.566 45.1035V33.3002M29.566 23.956C30.835 23.4334 34.1165 22.5165 37.8128 22.6542C38.4021 22.6762 38.9103 22.2164 38.9103 21.6267V19.7324C38.9103 18.9227 39.8222 18.4487 40.4849 18.914L49.3193 25.1169C49.8816 25.5117 49.8875 26.3429 49.3308 26.7456L40.4964 33.1364C39.8351 33.6148 38.9103 33.1423 38.9103 32.3262V30.3658C38.9103 29.8135 38.4625 29.3658 37.9103 29.3658H34.9758C32.025 29.3658 29.7627 30.9396 29.566 33.3002M29.566 23.956V33.3002"
                                      stroke="white"
                                      stroke-width="3"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <h5 className="text-white lh-base">
                                SbSe Reserve
                              </h5>
                            </div>
                          </div>
                        </Card.Body>
                        <div
                          className="bottom position-absolute top-0 start-0 bottom-0
                                        end-0"
                        >
                          <img
                            src={`${config.baseUrl}images/dashboard/shape/ellipseCard.svg`}
                            width={`100%`}
                            height={`100%`}
                            alt=""
                          />
                        </div>
                      </Card>
                      <Card className="dashboard-card box-gradient p-3 d-flex overflow-hidden gap-3 bgparticle">
                        <Card.Body className="">
                          <div className=" d-flex gap-3 justify-content-center align-items-center">
                            <div className="text-center">
                              <div className="mb-2">
                                <span className="SbSeIcon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 51 57"
                                    fill="none"
                                  >
                                    <path
                                      d="M38.4996 2.66699L48.8996 13.067M48.8996 13.067L38.4996 23.467M48.8996 13.067H14.5796C10.2112 13.067 8.02699 13.067 6.35848 13.9171C4.89082 14.665 3.69757 15.8582 2.94976 17.3259C2.09961 18.9944 2.09961 21.1786 2.09961 25.547V26.067M2.09961 44.267H36.4196C40.788 44.267 42.9722 44.267 44.6407 43.4168C46.1084 42.669 47.3016 41.4758 48.0495 40.0081C48.8996 38.3396 48.8996 36.1554 48.8996 31.787V31.267M2.09961 44.267L12.4996 54.667M2.09961 44.267L12.4996 33.867"
                                      stroke="white"
                                      stroke-width="4"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <h5 className="text-white lh-base">
                                USDT Rewards
                              </h5>
                            </div>
                          </div>
                        </Card.Body>
                        <div
                          className="bottom position-absolute top-0 start-0 bottom-0
                                        end-0"
                        >
                          <img
                            src={`${config.baseUrl}images/dashboard/shape/ellipseCard.svg`}
                            width={`100%`}
                            height={`100%`}
                            alt=""
                          />
                        </div>
                      </Card>
                    </Col>
                  </Row>
                )}
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Buy;
